import { ALL, AllProps } from '@lib/theme'
import styled from 'styled-components'

export interface SectionProps extends AllProps {}

const Section = styled.section<SectionProps>`
${ALL}`

export default Section
